export const rangeColumn = {
    label: {
        visible: !1,
        offset: 5,
        position: "inside",
        style: {
            lineWidth: 2,
            fill: {
                type: "palette",
                key: "axisMarkerFontColor"
            }
        },
        minLabel: {
            position: "end"
        },
        maxLabel: {
            position: "start"
        }
    }
};
//# sourceMappingURL=rangeColumn.js.map
